/* Novomur — Phone gate modal pour visualisation IA configurateur
   Capture le numero WhatsApp (mobile FR) avant la 1ere visualisation.
   Stockage en localStorage. Pas de cookies tiers.
   Compat : conserve les noms window.nmShowEmailGate / nmGetUserEmail
   pour ne pas casser les appels existants dans custom-creer.liquid. */
(function(){
  var NM_PHONE_KEY = 'nm_user_phone';

  /* Normalise un numero saisi -> format E.164 sans '+' : 33XXXXXXXXX
     Accepte : "06 12 34 56 78", "612345678", "+33 6 12...", "0033 6...".
     Retourne '' si invalide (doit etre un mobile FR : 9 chiffres, debute par 6 ou 7). */
  function nmNormalizePhone(raw){
    var d = String(raw || '').replace(/[^\d]/g, '');
    if (d.indexOf('0033') === 0) d = d.slice(4);
    else if (d.indexOf('33') === 0 && d.length === 11) d = d.slice(2);
    else if (d.indexOf('0') === 0) d = d.slice(1);
    /* d doit maintenant valoir 9 chiffres commencant par 6 ou 7 */
    if (/^[67]\d{8}$/.test(d)) return '33' + d;
    return '';
  }
  window.nmNormalizePhone = nmNormalizePhone;

  /* Getters — on garde les anciens noms pour compat avec custom-creer.liquid */
  window.nmGetUserPhone = function(){
    try { return localStorage.getItem(NM_PHONE_KEY) || ''; } catch(e){ return ''; }
  };
  /* Alias retro-compat : getEmail() du configurateur appelle nmGetUserEmail */
  window.nmGetUserEmail = window.nmGetUserPhone;
  window.nmIsValidPhone = function(p){ return !!nmNormalizePhone(p); };

  /* CSS injecte une seule fois */
  function injectCss(){
    if (document.getElementById('nmEgCss')) return;
    var s = document.createElement('style');
    s.id = 'nmEgCss';
    s.textContent =
      '#nmEmailGate{position:fixed;inset:0;z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .22s ease;}' +
      '#nmEmailGate.nm-eg--on{opacity:1;}' +
      '.nm-eg__backdrop{position:absolute;inset:0;background:rgba(30,26,20,.55);backdrop-filter:blur(4px);}' +
      '.nm-eg__modal{position:relative;background:#fff;border-radius:16px;padding:36px 32px;max-width:440px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.25);transform:translateY(8px) scale(.98);transition:transform .22s cubic-bezier(.22,.61,.36,1);}' +
      '#nmEmailGate.nm-eg--on .nm-eg__modal{transform:translateY(0) scale(1);}' +
      '.nm-eg__close{position:absolute;top:12px;right:12px;background:none;border:none;font-size:24px;color:#999;cursor:pointer;line-height:1;padding:6px 10px;}' +
      '.nm-eg__close:hover{color:#1e1a14;}' +
      '.nm-eg__icon{color:#25D366;margin-bottom:10px;}' +
      '.nm-eg__eyebrow{font-family:"DM Sans",sans-serif;font-size:.72rem;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#C5A059;margin:0 0 8px;}' +
      '.nm-eg__title{margin:0 0 12px;font-family:"Jost",serif;font-size:1.5rem;font-weight:400;color:#1e1a14;line-height:1.25;}' +
      '.nm-eg__title em{font-style:italic;color:#C5A059;}' +
      '.nm-eg__sub{margin:0 0 16px;font-size:14px;color:#555;line-height:1.5;}' +
      '.nm-eg__field{display:flex;align-items:stretch;border:1px solid #E0DBD0;border-radius:8px;overflow:hidden;margin-bottom:6px;transition:border-color .15s;}' +
      '.nm-eg__field:focus-within{border-color:#C5A059;}' +
      '.nm-eg__field--error{border-color:#c0392b;}' +
      '.nm-eg__prefix{display:flex;align-items:center;gap:5px;padding:0 12px;background:#F7F4EE;border-right:1px solid #E0DBD0;font-size:14px;color:#1e1a14;white-space:nowrap;}' +
      '.nm-eg__input{flex:1;min-width:0;padding:13px 14px;border:none;font-size:15px;font-family:inherit;outline:none;color:#1e1a14;letter-spacing:.02em;}' +
      '.nm-eg__err{display:none;font-size:12px;color:#c0392b;margin:0 0 12px;text-align:left;padding-left:2px;}' +
      '.nm-eg__err--on{display:block;}' +
      '.nm-eg__btn{width:100%;display:flex;align-items:center;justify-content:center;gap:8px;padding:14px 18px;margin-top:8px;background:#C5A059;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;transition:background .15s;}' +
      '.nm-eg__btn:hover{background:#b08d57;}' +
      '.nm-eg__legal{font-size:11px;color:#999;margin:14px 0 0;line-height:1.45;}' +
      '.nm-eg__legal a{color:#999;text-decoration:underline;}' +
    '.nm-eg__skip{display:block;width:100%;margin:10px 0 0;padding:10px;background:none;border:none;font:inherit;font-size:13px;color:#555;text-decoration:underline;text-underline-offset:3px;cursor:pointer;}' +
    '.nm-eg__skip:hover{color:#1e1a14;}' +
    '.nm-eg__icon--mail{color:#C5A059;}' +
    '.nm-eg__opt{display:flex;gap:9px;align-items:flex-start;text-align:left;font-size:12.5px;color:#555;line-height:1.45;margin:10px 0 2px;cursor:pointer;}' +
    '.nm-eg__opt input{flex-shrink:0;width:17px;height:17px;margin:1px 0 0;accent-color:#C5A059;}';
    document.head.appendChild(s);
  }

  /* Affiche le modal. cb(numeroNormalise) appele apres validation. */
  window.nmShowPhoneGate = function(cb){
    injectCss();
    var ex = document.getElementById('nmEmailGate');
    if (ex) ex.remove();

    var o = document.createElement('div');
    o.id = 'nmEmailGate';
    o.innerHTML =
      '<div class="nm-eg__backdrop"></div>' +
      '<div class="nm-eg__modal" role="dialog" aria-modal="true" aria-label="Visualisation sur votre mur">' +
        '<button type="button" class="nm-eg__close" aria-label="Fermer">&times;</button>' +
        '<div class="nm-eg__icon">' +
          '<svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.11.82.83-3.04-.2-.31a8.23 8.23 0 0 1-1.26-4.39c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.42-.14 0-.31-.02-.47-.02-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.25 3.75.59.26 1.06.41 1.42.52.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28Z"/>' +
          '</svg>' +
        '</div>' +
        '<p class="nm-eg__eyebrow">Visualisation sur votre mur</p>' +
        '<h3 class="nm-eg__title">Voyez votre <em>cr&eacute;ation</em> en situation</h3>' +
        '<p class="nm-eg__sub">Notre IA applique votre design sur la photo de votre mur, &agrave; vos dimensions. Indiquez votre num&eacute;ro WhatsApp pour g&eacute;n&eacute;rer votre aper&ccedil;u. Aper&ccedil;u indicatif : le cadrage et les couleurs peuvent diff&eacute;rer du r&eacute;sultat imprim&eacute;.</p>' +
        '<form class="nm-eg__form" novalidate>' +
          '<div class="nm-eg__field">' +
            '<span class="nm-eg__prefix">&#127467;&#127479; +33</span>' +
            '<input type="tel" name="phone" class="nm-eg__input" required placeholder="6 12 34 56 78" autocomplete="tel-national" inputmode="numeric" maxlength="14" />' +
          '</div>' +
          '<p class="nm-eg__err">Num&eacute;ro invalide &mdash; mobile fran&ccedil;ais &agrave; 9 chiffres attendu.</p>' +
          '<button type="submit" class="nm-eg__btn">G&eacute;n&eacute;rer mon aper&ccedil;u ' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
          '</button>' +
        '</form>' +
        '<button type="button" class="nm-eg__skip">Continuer sans visualisation</button>' +
        '<p class="nm-eg__legal">3 visualisations offertes. En continuant, vous acceptez d\'&ecirc;tre recontact&eacute; par WhatsApp/SMS. D&eacute;sinscription &agrave; tout moment. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Politique de confidentialit&eacute;</a>.</p>' +
      '</div>';
    document.body.appendChild(o);
    requestAnimationFrame(function(){ o.classList.add('nm-eg--on'); });

    var ip   = o.querySelector('input[name="phone"]');
    var fld  = o.querySelector('.nm-eg__field');
    var err  = o.querySelector('.nm-eg__err');
    setTimeout(function(){ ip && ip.focus(); }, 200);

    function cl(){
      o.classList.remove('nm-eg--on');
      setTimeout(function(){ o.remove(); }, 220);
    }
    o.querySelector('.nm-eg__close').addEventListener('click', cl);
    o.querySelector('.nm-eg__backdrop').addEventListener('click', cl);
    var skip = o.querySelector('.nm-eg__skip'); if (skip) skip.addEventListener('click', cl);

    /* Retire l'erreur des que l'utilisateur retape */
    ip.addEventListener('input', function(){
      fld.classList.remove('nm-eg__field--error');
      err.classList.remove('nm-eg__err--on');
    });

    o.querySelector('.nm-eg__form').addEventListener('submit', function(ev){
      ev.preventDefault();
      var normalized = nmNormalizePhone(ip.value);
      if (!normalized){
        fld.classList.add('nm-eg__field--error');
        err.classList.add('nm-eg__err--on');
        ip.focus();
        return;
      }
      try { localStorage.setItem(NM_PHONE_KEY, normalized); } catch(e){}
      cl();
      if (typeof cb === 'function') cb(normalized);
    });
  };

  /* Alias retro-compat : custom-creer.liquid appelle window.nmShowEmailGate */
  window.nmShowEmailGate = window.nmShowPhoneGate;

  window.NM_PHONE_KEY = NM_PHONE_KEY;

  /* ── Variante e-mail (fiche produit, 02/10) ──
     L'adresse sert d'identifiant pour la limite d'aperçus du worker IA (3 par adresse).
     Inscription à la newsletter UNIQUEMENT si la case est cochée : consentement libre, jamais pré-coché. */
  var NM_EMAIL_KEY = 'nm_user_email';
  function nmValidEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(e || '').trim()); }
  window.nmGetVizEmail = function(){
    try { var e = localStorage.getItem(NM_EMAIL_KEY) || ''; return nmValidEmail(e) ? e : ''; } catch(x){ return ''; }
  };
  window.nmShowMailGate = function(cb, source){
    injectCss();
    var ex = document.getElementById('nmEmailGate');
    if (ex) ex.remove();
    var o = document.createElement('div');
    o.id = 'nmEmailGate';
    o.innerHTML =
      '<div class="nm-eg__backdrop"></div>' +
      '<div class="nm-eg__modal" role="dialog" aria-modal="true" aria-label="Voir ce design sur votre mur">' +
        '<button type="button" class="nm-eg__close" aria-label="Fermer">&times;</button>' +
        '<div class="nm-eg__icon nm-eg__icon--mail"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/></svg></div>' +
        '<p class="nm-eg__eyebrow">Visualisation sur votre mur</p>' +
        '<h3 class="nm-eg__title">Voyez ce design <em>chez vous</em></h3>' +
        '<p class="nm-eg__sub">Notre IA applique ce design sur la photo de votre mur, &agrave; vos dimensions. Indiquez votre e-mail pour g&eacute;n&eacute;rer votre aper&ccedil;u. Aper&ccedil;u indicatif : le cadrage et les couleurs peuvent diff&eacute;rer du r&eacute;sultat imprim&eacute;.</p>' +
        '<form class="nm-eg__form" novalidate>' +
          '<div class="nm-eg__field"><input type="email" name="email" class="nm-eg__input" required placeholder="votre@email.fr" autocomplete="email" inputmode="email" /></div>' +
          '<p class="nm-eg__err">Adresse e-mail invalide.</p>' +
          '<label class="nm-eg__opt"><input type="checkbox" name="news"> <span>Recevoir aussi nos id&eacute;es d&eacute;co et nos offres par e-mail (d&eacute;sinscription en un clic).</span></label>' +
          '<button type="submit" class="nm-eg__btn">G&eacute;n&eacute;rer mon aper&ccedil;u ' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
          '</button>' +
        '</form>' +
        '<p class="nm-eg__legal">3 aper&ccedil;us offerts par adresse e-mail. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Politique de confidentialit&eacute;</a>.</p>' +
      '</div>';
    document.body.appendChild(o);
    requestAnimationFrame(function(){ o.classList.add('nm-eg--on'); });
    var ip  = o.querySelector('input[name="email"]');
    var fld = o.querySelector('.nm-eg__field');
    var err = o.querySelector('.nm-eg__err');
    setTimeout(function(){ ip && ip.focus(); }, 200);
    function cl(){ o.classList.remove('nm-eg--on'); setTimeout(function(){ o.remove(); }, 220); }
    o.querySelector('.nm-eg__close').addEventListener('click', cl);
    o.querySelector('.nm-eg__backdrop').addEventListener('click', cl);
    ip.addEventListener('input', function(){ fld.classList.remove('nm-eg__field--error'); err.classList.remove('nm-eg__err--on'); });
    o.querySelector('.nm-eg__form').addEventListener('submit', function(ev){
      ev.preventDefault();
      var em = String(ip.value || '').trim().toLowerCase();
      if (!nmValidEmail(em)) { fld.classList.add('nm-eg__field--error'); err.classList.add('nm-eg__err--on'); ip.focus(); return; }
      try { localStorage.setItem(NM_EMAIL_KEY, em); } catch(x){}
      if (o.querySelector('input[name="news"]').checked) {
        /* Même relais que la pop-up newsletter (l'API Klaviyo refuse l'appel direct du navigateur). */
        fetch('https://novomur-newsletter.novomur.workers.dev/', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: em, source: source || 'Visualisation IA' })
        }).then(function(r){ return r.ok ? r.json() : null; }).then(function(res){
          if (res && res.ok === true && window.nmInscrit) window.nmInscrit(em); /* relance du panier (tiroir) */
        }).catch(function(){});
      }
      cl();
      if (typeof cb === 'function') cb(em);
    });
  };
})();
